import { conformToMask } from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {

  cropText(text) {
    return (text) ? text.substring(0, 30) + '...' : ''
  },

  capitalize(str) {
    if (!str) {
      return ''
    }
    str = str.replace(/-/gi, ' ')
    str = str.trim()

    str = str.toLowerCase().split(' ')
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].split('')
      str[i][0] = str[i][0].toUpperCase()
      str[i] = str[i].join('')
    }
    return str.join(' ')
    // return (string) ? string.charAt(0).toUpperCase() + string.slice(1) : ''; // only for one word
  },

  money(text) {

    text = String(text).replace('.', ',')

    const moneyMask = createNumberMask({
      prefix: 'R$ ',
      thousandsSeparatorSymbol: '.',
      allowDecimal: true,
      decimalSymbol: ',',
    })

    let conformedMoneyNumber = conformToMask (
      text,
      moneyMask,
      { guide: false }
    )

    return (text) ? conformedMoneyNumber.conformedValue : ''
  },

  moneyThousand(text) {
    let value
    if (text) {
      value = this.money(text)
      value = value.replace(/R\$ ([0-9]{1,3})(.+)$$/g, '$1')
    }
    return (value) ? `R$ ${value} mil` : ''
  },

  moneyBi(number) {
    let cents = '.00'
    let newNumber = number
    if (newNumber) {
      newNumber = newNumber + cents
    }
    return newNumber
    // return number.toFixed(2)
  },

  removeAccents(strAccents) {
    if (strAccents !== undefined) {
      strAccents = strAccents.split('')
      let strAccentsOut = []
      let strAccentsLen = strAccents.length
      let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž'
      let accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz'
      for (let y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) !== -1) {
          strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1)
        } else {
          strAccentsOut[y] = strAccents[y]
        }
      }
      strAccentsOut = strAccentsOut.join('')
      return strAccentsOut.replace(/ /g, '-').toLowerCase()
    } else {
      return undefined
    }
  },
}



// WEBPACK FOOTER //
// ./src/helpers/filters.js